@if (isMatMenu) {
  <button mat-menu-item
          data-test="dms-removeFolder-button"
          [matTooltip]="title"
          [matTooltipDisabled]="isMatMenu"
          (click)="removeFolder()">
    <i [hidden]="labelOnly" class="icon fa-fw fas fa-trash"></i>
    <label [hidden]="iconOnly" class="mb-0">{{ title }}</label>
  </button>
} @else {
  <sk-button [appearance]="iconOnly ? 'icon' : 'text'"
             data-test="dms-removeFolder-button"
             [color]="iconOnly ? 'unspecified' : 'primary'"
             [label]="!iconOnly ? title : ''"
             [ngClass]="btnClass"
             [matTooltip]="title"
             [matTooltipDisabled]="isMatMenu"
             (click)="removeFolder()">
    @if (iconOnly) {
      <i [hidden]="labelOnly" class="icon fa-fw fas fa-trash"></i>
    } @else {
      <ng-template buttonPrefix>
        <i [hidden]="labelOnly" class="icon fa-fw fas fa-trash"></i>
      </ng-template>
    }
  </sk-button>
}
